import { useEffect } from "react";
import { Link } from "react-router-dom";
import { copy } from "../copy";

export default function NotFound() {
  useEffect(() => {
    document.title = copy.notFound.title;
  }, []);

  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden px-4 pt-20 text-center">
      <p
        aria-hidden
        className="pointer-events-none absolute bottom-0 select-none font-headline text-[40vw] leading-none text-ground-raised md:text-[18rem]"
      >
        {copy.notFound.code}
      </p>
      <div className="relative">
        <h1 className="font-headline text-5xl uppercase leading-[0.9] tracking-[-0.02em] text-gold md:text-7xl">
          {copy.notFound.heading}
        </h1>
        <p className="mt-4 text-base text-chrome-dim md:text-lg">{copy.notFound.body}</p>
        <Link
          to="/"
          className="bf-focusable mt-8 inline-flex h-12 items-center rounded-md bg-money px-7 text-sm font-bold uppercase tracking-[0.12em] text-ground transition-colors hover:bg-money-deep"
        >
          {copy.notFound.home}
        </Link>
      </div>
    </main>
  );
}
